"use client";

// src/components/hover-icon/hover-icon.tsx
import { useMemo, useState } from "react";
import { tv } from "tailwind-variants";
import { jsx, jsxs } from "react/jsx-runtime";
var hoverIconVariants = tv({
  base: "absolute flex items-center justify-center top-0 left-0 transition-opacity duration-300 ease-in-out w-full h-full",
  variants: {
    visible: {
      true: "opacity-100",
      false: "opacity-0"
    }
  }
});
var HoverIcon = ({
  defaultIcon: DefaultIcon,
  hoverIcon: HoverIconComp,
  iconName,
  size,
  color
}) => {
  const [hovered, setHovered] = useState(false);
  const defaultIconMemo = useMemo(
    () => /* @__PURE__ */ jsx(DefaultIcon, { size, color }),
    [DefaultIcon, size, color]
  );
  const hoverIconMemo = useMemo(
    () => /* @__PURE__ */ jsx(HoverIconComp, { size, color }),
    [HoverIcon, size, color]
  );
  return /* @__PURE__ */ jsxs(
    "span",
    {
      tabIndex: -1,
      onPointerEnter: () => setHovered(true),
      onPointerLeave: () => setHovered(false),
      style: {
        position: "relative",
        display: "inline-block",
        width: size,
        height: size
      },
      children: [
        /* @__PURE__ */ jsx(
          "span",
          {
            className: hoverIconVariants({ visible: !hovered }),
            role: "img",
            "aria-label": `${iconName ?? "icon"}`,
            "aria-hidden": hovered,
            children: defaultIconMemo
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: hoverIconVariants({ visible: hovered }),
            role: "img",
            "aria-label": `${iconName ?? "icon"} hovered`,
            "aria-hidden": !hovered,
            children: hoverIconMemo
          }
        )
      ]
    }
  );
};
export {
  HoverIcon
};
